import React, { useState } from "react";
import { HiArrowRight } from "react-icons/hi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./nav.css"
import { Navigate } from "react-router-dom";
import Justaclickaway from "../JustaClickaway/Justaclickaway";
import { Routes, Route } from "react-router-dom";

<Routes>
  <Route path="/justaclickaway" element={<Justaclickaway />} />
</Routes>
function Nav() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleClick = () => {
    setIsOpen(!isOpen);
  };

  const handleClick = () => {
    setIsOpen(false);
  };

  return (
    <div className="section">
      <nav>
        <div className={`left-nav-content ${isOpen ? "show" : ""}`}>
          <Link
            to="/"
            onClick={handleClick}
            style={{ color: location.pathname === "/" ? "#FF9A00" : "#000d44" }}
          >
            Home
          </Link>
          <Link
            to="/about"
            onClick={handleClick}
            style={{
              color: location.pathname === "/about" ? "#FF9A00" : "#000d44",
            }}
          >
            About
          </Link>
          {/* <Link to="/specialities" onClick={handleClick}>Specialities</Link> */}
          <Link
            to="/contact"
            onClick={handleClick}
            style={{
              color: location.pathname === "/contact" ? "#FF9A00" : "#000d44",
            }}
          >
            Contact
          </Link>
          <Link
            to="/blog"
            onClick={handleClick}
            style={{
              color:
                location.pathname === "/blog" ||
                  location.pathname.startsWith("/blog/")
                  ? "#FF9A00"
                  : "#000d44",
            }}
          >
            Blog
          </Link>

          <div className="resp-icon">
            <FaTimes onClick={() => setIsOpen(false)} />
          </div>
        </div>

        <div className="right-nav-content">
          <button
            onClick={() => {
              navigate('./', { state: { scrollTo: 'appointment-section' } });
            }}
          >
            Make an Appointment <HiArrowRight />
          </button>


          <span className="menu-icon" >
            {isOpen ? (
              <FaTimes className="nav-icon" />
            ) : (
              <FaBars className="nav-icon" />
            )}
          </span>
        </div>
      </nav>
    </div>
  );
}

export default Nav;
